import axios from 'axios';
import { getCookie, removeCookie } from './Cookie'; // 쿠키 관련 함수
import store from 'store'; // Redux store
import { logout } from 'slices/loginSlice'; // 로그아웃 액션

//디바이스 감지
const detectDevice = () => /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'PC';

const detectBrowser = () => {
  const ua = navigator.userAgent;
  if (/Chrome/i.test(ua)) return 'Chrome';
  if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) return 'Safari';
  if (/Firefox/i.test(ua)) return 'Firefox';
  if (/Edge/i.test(ua)) return 'Edge';
  if (/MSIE|Trident/i.test(ua)) return 'IE';
  return 'Other';
};

const axiosAuth = axios.create({});

// 요청 인터셉터 추가
axiosAuth.interceptors.request.use(
  (config) => {

    console.log('[AXIOS AUTH 요청]', config.url);
    console.log('X-Device:', detectDevice());
    console.log('X-User:', store.getState()?.loginSlice?.userInfo?.email);
    
    const token = getCookie('accessToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    //브라우저/디바이스 정보 자동 헤더 추가
    config.headers['X-Device'] = detectDevice();
    config.headers['X-Browser'] = detectBrowser();

    // 로그인한 사용자 정보 (Redux에서 가져오기)
    const state = store.getState();
    // console.log('store.getState();',store.getState());
    const userEmail = state?.loginSlice?.userInfo?.email || 'Anonymous';
    config.headers['X-User'] = userEmail;

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axiosAuth.interceptors.response.use(
  (response) => {
    console.log('response', response);
    return response;
  },
  (error) => {
    console.log(error);

    if (error.response && error.response.status === 401) {
      // 401 Unauthorized 에러가 발생하면 로그아웃 처리
      store.dispatch(logout()); // 로그아웃 액션 디스패치
      removeCookie('accessToken'); // 쿠키에서 토큰 삭제

      // 로그아웃 후 로그인 페이지로 리디렉션
      window.location.href = '/login';
    }else if (error.response && error.response.status === 403) {
      window.location.href = '/*?code=403';
    }else if (error.response && error.response.status === 404) {
      window.location.href = '/*?code=404';
    }else if (error.response && error.response.status === 500) {
      window.location.href = '/*?code=500';
    }
    return Promise.reject(error);
  }
);

export default axiosAuth;
